<script>
const logoImgSrc = require("./assets/logo.png")
const centerBgImgSrc = require("./assets/card3.png")
const healthBgImgSrc = require("./assets/card1.png")
const bookBgImgSrc = require("./assets/card2.png")
const whiteArrowImgSrc = require("./assets/jiantou-white.png")
const blueArrowImgSrc = require("./assets/jiantou-blue.png")
const greenArrowImgSrc = require("./assets/jiantou-green.png")
const banner1ImgSrc = require("./assets/banner/banner1.jpg")
const banner2ImgSrc = require("./assets/banner/banner2.jpg")
const banner3ImgSrc = require("./assets/banner/banner3.jpg")
const mapAltImgSrc = require("./assets/mapalt.png")
const assistImgSrc = require("./assets/assist.png")

const apiBase = "https://emu.ameow.xyz/public/index.php"
const apiService = {
  login: "/patient/login",
  register: "/patient/register",
  logout: "/patient/logout",
  getPatient: "/patient/getPatient",
  updatePatient: "/patient/updatePatient",
  getNotVaccinated: "/vaccine/getNotVaccinated",
  getAllVaccineType: "/vaccine/getAllVaccineType",
  getVaccinated: "/vaccine/getVaccinated",
  search: "/appointment/search",
  getAppointment: "/appointment/getAppointment",
  addAppointment: "/appointment/addAppointment",
  getAllAppointment: "/appointment/getAllAppointment",
}

function assureLogin(context) {
  if (localStorage.getItem("loginToken") === null) {
    context.$router.push("/login")
  }
}

export default {
  name: "common",
  logoImgSrc,
  centerBgImgSrc,
  healthBgImgSrc,
  bookBgImgSrc,
  whiteArrowImgSrc,
  blueArrowImgSrc,
  greenArrowImgSrc,
  banner1ImgSrc,
  banner2ImgSrc,
  banner3ImgSrc,
  mapAltImgSrc,
  assistImgSrc,
  apiBase,
  apiService,
  assureLogin,
}
</script>
